'use strict';

window.CFC = window.CFC || {};
window.CFC.Carousels = (function($) {
  var gridCarouselBreakpoint_enabled = 800;
  var gridCarouselBreakpoint2 = 640;
  
  var carouselBreakpoint4 = 1024;
  var carouselBreakpoint3 = 640;
  var carouselBreakpoint2 = 480;
  
  var carouselCurrentlyEnabled = false;
  var throttledApplyCarouselToGridOfThree;
  
  function init() {
    initCarouselSections();
    initGridOfThreeCarousels();
  }
  
  function initCarouselSections() {
    var $carousel = $(".carousel");
    if (!$carousel.length) { return; }
    
    var responsiveCarouselOptions = { 0: { items: 1, stagePadding: 60 } };
    responsiveCarouselOptions[carouselBreakpoint2] = { items: 2 };
    responsiveCarouselOptions[carouselBreakpoint3] = { items: 3, nav: true };
    responsiveCarouselOptions[carouselBreakpoint4] = { items: 4, nav: true,  };
    
    var carouselOptions = {
      items: 4,
      loop: true,
      margin: 20,
      center: false,
      nav: false,
      navText: [ '<i class="fas fa-arrow-left" aria-label="' + window.cfctx['Previous'] + '"></i>', '<i class="fas fa-arrow-right" aria-label="' + window.cfctx['Next'] + '"></i>' ],
      responsive: responsiveCarouselOptions
    }

    $carousel.owlCarousel(carouselOptions);
    
    $(window).resize(window._.throttle(function() {
      $carousel.owlCarousel('refresh');
    }, 100));
  }
  
  function shouldEnableCarousel() { return (window.innerWidth < gridCarouselBreakpoint_enabled); }
  
  function applyCarouselToGridOfThreeIfApplicable(force) {
    var enableCarousel = shouldEnableCarousel();

    if (force || (enableCarousel !== carouselCurrentlyEnabled)) {
      throttledApplyCarouselToGridOfThree();
    }
    
    carouselCurrentlyEnabled = enableCarousel;
  }
  
  function get$GridOfThreeCarousels() {
    return $('.owl-theme .gridOfThreeCards, .relatedLinks')
  }
  
  function initGridOfThreeCarousels() {
    var responsiveCarouselOptions = { 0: { items: 1 } };
    responsiveCarouselOptions[gridCarouselBreakpoint2] = { items: 2 };

    var carouselOptions = {
      loop: false,
      margin: 20,
      center: false,
      nav: false,
      dots: true,
      stagePadding: 30,
      responsive: responsiveCarouselOptions
    };
    
    throttledApplyCarouselToGridOfThree = window._.throttle(function() {
      get$GridOfThreeCarousels().each(function() {
        var $grid = $(this);
        var enabled = shouldEnableCarousel();
        var gridIsCarousel = $grid.hasClass('owl-carousel');
        
        $grid.toggleClass('owl-carousel', enabled);
        $grid.owlCarousel('destroy');
 
        if (enabled) {
          $grid.owlCarousel(carouselOptions);           
        }
      });
    }, 100, { leading: false, trailing: true });

    applyCarouselToGridOfThreeIfApplicable(true);
    $(window).resize(applyCarouselToGridOfThreeIfApplicable);
  }
  
  
  $(init);
})(jQuery);
